import {ScreenProp} from 'src/app/models'
import {AdminScreen} from '../page/Admin/Screen'
import {AgenScreen} from '../page/Agen/Screen'
import {HakAksesScreen} from '../page/HakAkses/Screen'

type AdminKeys = keyof typeof AdminScreen
type AgenKeys = keyof typeof AgenScreen
type HakAksesKeys = keyof typeof HakAksesScreen

type TKeys = 'USER' | AdminKeys | AgenKeys | HakAksesKeys

const UserScreens: Record<TKeys, ScreenProp> = {
  USER: {
    PATH: '/user',
    TITLE: 'Manajemen Pengguna',
    TITLE_ALT: 'Pengguna',
  },

  ...HakAksesScreen,
  ...AdminScreen,
  ...AgenScreen,
}

export default UserScreens
